import { useDebugValue } from 'react';
import { isEmptyString } from 'utils/stringHelpers';
import { useConditionFieldNameWatch } from './form/watchers/useConditionFieldNameWatch';

export const useHasConditionFieldName = () => {
  const fieldName = useConditionFieldNameWatch();
  const hasFieldName = !isEmptyString(fieldName);
  useDebugValue(hasFieldName);
  return hasFieldName;
};
